export const chainPurchase = {
  methods: {
    handlePurchase(payPackage) {
      if (
        !payPackage ||
        !payPackage.sku ||
        !payPackage.sku.prices ||
        !payPackage.sku.prices.length
      ) {
        console.error("Invalid chain package data:", payPackage);
        return;
      }

      const webPrice = payPackage.sku.prices.find((p) => p.platform === "web");
      const price = webPrice?.price;

      // Zero-price package → claim flow (not the paid payment flow).
      if (Number(price) === 0) {
        this.playSoundTab();
        this.firebaseClickItemOffer(
          "offer_claim_button_" + payPackage.id + "#"
        );
        this.claimPackage(payPackage);
        return;
      }

      this.playSoundTab();
      this.firebaseClickItemOffer("offer_buy_button_" + payPackage.id + "#");

      const locale = this.$store.state.locale || "de_DE";
      const displayConfig =
        typeof payPackage.display_config === "string"
          ? JSON.parse(payPackage.display_config)
          : payPackage.display_config;

      const localizedName =
        (displayConfig && displayConfig.name && displayConfig.name[locale]) ||
        (displayConfig && displayConfig.name && displayConfig.name.fallback) ||
        payPackage.name;

      const packageData = {
        id: payPackage.id,
        package: {
          id: payPackage.id,
          name: payPackage.name,
          slug: payPackage.slug || "offer-chain",
          price,
          items: payPackage.assets || [],
        },
        rewards: this.parseRewardsFromAssets(payPackage.assets),
        category: "Offer",
        variant: "Chain",
        customName: localizedName,
        customImg:
          payPackage.image_path_full ||
          this.chainOffer.badge_image_path_full ||
          "",
        v2Package: payPackage,
        v2OfferId: this.chainOffer.id,
      };

      this.$store.commit("shop/setShopChosenPackage", packageData);
      this.$bvModal.show("modal-payment");
    },
  },
};
